import React, { Component } from "react";
import calcularPx from "../calcularPx";
import { Link } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { ReactComponent as IcoChevron } from "../../../res/iconos/chevron.svg";

class RegionMobile extends Component {
  state = { mostrarSubmenu: false };

  style1 = {
    position: "relative",
    display: "block",
    width: "100%",
    padding: "30px 10%",
    textAlign: "left",
    alignItems: "baseline",
    background: "transparent",
    border: "none",
    color: "#41454c",
    fontWeight: 700
  };

  style2 = {
    position: "relative",
    display: "block",
    color: "#3f3f46",
    padding: "30px 10%",
    textDecoration: "none",
    fontFamily: "Open Sans",
    fontSize: 16,
    fontWeight: 500,
    background: "transparent",
    border: "none",
  };

  render() {
    const { ocultar, setRegion } = this.props;
    return (
      <React.Fragment>
        <div>
          <button
            className={"itemNavBar"}
            style={this.style1}
            onClick={() => {
              this.setState({ mostrarSubmenu: !this.state.mostrarSubmenu });
            }}
          >
            <img 
              src={require(`../../../res/iconos/region_int_black.png`)} 
              style={{
                height: 25,
                position: "relative",
                display: "inline",
                marginRight: 20,
              }}
            />
            Región
            <IcoChevron
              width={15}
              height={15}
              style={{
                position: "absolute",
                right: "10%",
                stroke: "#41454c",
                transform:
                  "scaleY(" + (this.state.mostrarSubmenu ? -1 : 1) + ")",
              }}
            />
          </button>
          <CSSTransition
            in={this.state.mostrarSubmenu}
            timeout={100}
            classNames="opacidad"
            unmountOnExit
          >
            <nav
              className={"submenuProductos"}
              style={{
                background: "#ffffff",
                position: "relative",
                marginLeft: "2%",
                marginRight: "2%",
                marginBottom: 10,
                paddingLeft: 15,
                //paddingTop: 15,
                paddingBottom: 15,
                paddingRight: 15,
                width: "auto",
                background: "#ffffff",
                borderRadius: 25
              }}
            >
              <button
                onClick={() => {
                  this.setState({ mostrarSubmenu: false });
                  ocultar();
                  setRegion(null);
                }}
                style={this.style2}
              >
                <img 
                  src={require(`../../../res/iconos/region_argentina.png`)} 
                  style={{
                    height: 25,
                    position: "relative",
                    display: "inline",
                    marginRight: calcularPx(20),
                  }}
                />
                Argentina
              </button>
              <button
                onClick={() => {
                  this.setState({ mostrarSubmenu: false });
                  ocultar();
                  setRegion('bolivia');
                }}
                style={this.style2}
              >
                <img 
                  src={require(`../../../res/iconos/region_bolivia.png`)} 
                  style={{
                    height: 25,
                    position: "relative",
                    display: "inline",
                    marginRight: calcularPx(20),
                  }}
                />
                Bolivia
              </button>
              <button
                onClick={() => {
                  this.setState({ mostrarSubmenu: false });
                  ocultar();
                  setRegion('mexico');
                }}
                style={this.style2}
              >
                <img 
                  src={require(`../../../res/iconos/region_mexico.png`)} 
                  style={{
                    height: 25,
                    position: "relative",
                    display: "inline",
                    marginRight: calcularPx(20),
                  }}
                />
                México
              </button>
            </nav>
          </CSSTransition>
        </div>
      </React.Fragment>
    );
  }
}

export default RegionMobile;
